<template>
  <v-app light>
    <router-view />
    <BlockUI
      style="color: #1976D2; font-size: 18px;"
      :message="$root.blockUImsg"
      v-if="$root.blockUIshow"
    >
      <v-progress-circular :size="60" :width="4" color="primary" indeterminate></v-progress-circular>
    </BlockUI>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>
